import LogicaAPI from "./logicaapi";

class Entitlements extends LogicaAPI {
  async howtoAcquisition(right_id) {
    const params = {
      right_id,
      device_code: this.config.deviceCode,
      app_id: this.config.appId,
    };
    return this.get("/api/v1/entitlements/howto_acquisition", {params});
  }
}
export default Entitlements;
